// Tab 配置表 — 定义各渠道 Tab 的 key、label、组件映射
// 新增渠道时只需在此添加条目

import TiktokTab from './TiktokTab';
import YoutubeTab from './YoutubeTab';
import XTab from './XTab';
import BilibiliTab from './BilibiliTab';
import DouyinTab from './DouyinTab';
import AIGalleryReportTab from './AIGalleryReportTab';

export interface ITabConfigItem {
  key: string;
  label: string;
  component: React.ComponentType<any>;
  /** 是否使用 ChannelLabel 渲染标签（默认 true）；非渠道 Tab 设为 false */
  useChannelLabel?: boolean;
}

export const TAB_CONFIG: ITabConfigItem[] = [
  { key: 'tiktok', label: 'TikTok', component: TiktokTab },
  { key: 'youtube', label: 'YouTube', component: YoutubeTab },
  { key: 'twitter', label: 'X', component: XTab },
  { key: 'bilibili', label: 'Bilibili', component: BilibiliTab },
  { key: 'douyin', label: 'Douyin', component: DouyinTab },
  {
    key: 'trending',
    label: 'Video Trends',
    component: AIGalleryReportTab,
    useChannelLabel: false,
  },
];

export const DEFAULT_TAB = 'tiktok';
